if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"admin","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(1(000|338|376|401|586|758|825)|2(056|065|160|247|268|484|712|814|972)|4((2|37|43)2|046|526|744|880)|5(14|244|252|616|638)|6(009|456|540|592|628|904)|7(021|276|302)|8([78]30|102|88)|9(024|230|280|429|622)|38|396)$/.test(chunkId)},
		rootOutputDir: "",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}